import React from 'react';
import { Colors } from '@/constants/Colors';

interface ButtonProps {
  title: string;
  onPress: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'small' | 'medium' | 'large';
  isLoading?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  icon?: React.ReactNode;
}

const sizeMap = {
  small: { height: 36, paddingLeft: 16, paddingRight: 16 },
  medium: { height: 48, paddingLeft: 24, paddingRight: 24 },
  large: { height: 56, paddingLeft: 32, paddingRight: 32 },
};

export function Button({
  title,
  onPress,
  variant = 'primary',
  size = 'medium',
  isLoading = false,
  disabled = false,
  style,
  icon,
}: ButtonProps) {
  const getStyle = (): React.CSSProperties => {
    const base: React.CSSProperties = {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 28,
      gap: 8,
      cursor: disabled ? 'not-allowed' : 'pointer',
      border: 'none',
      width: '100%',
      ...sizeMap[size],
    };

    switch (variant) {
      case 'primary':
        return { ...base, backgroundColor: disabled ? `${Colors.primary}80` : Colors.primary, color: '#ffffff' };
      case 'secondary':
        return { ...base, backgroundColor: `${Colors.primary}15`, color: Colors.primary };
      case 'outline':
        return { ...base, backgroundColor: 'transparent', border: `1px solid ${Colors.primary}`, color: Colors.primary };
      default:
        return base;
    }
  };

  return (
    <button onClick={onPress} disabled={disabled || isLoading} style={{ ...getStyle(), ...style }}>
      {isLoading ? (
        <div className="spinner spinner-small" />
      ) : (
        <>
          {icon}
          <span style={{ fontSize: 16, fontWeight: 700 }}>{title}</span>
        </>
      )}
    </button>
  );
}
